module.exports = __webpack_public_path__ + "static/next-chapter-b1419621f8fd114e18a122515cf1f39f.png";